// 입력값 방어 유틸 (SQLi / XSS 완화)
// 정책: 위험 문자를 입력 시점에 감지 → 필드 아래 에러 메시지 노출 + 제출 차단.
//       제출 직전 sanitize* 로 최종 방어(defense-in-depth).
// 비밀번호 필드에는 hasForbiddenChars 검증을 쓰지 말 것 — 특수문자가 정상 허용이며,
// 로그인 비밀번호를 필터링하면 기존 사용자가 로그인하지 못한다.

// XSS/SQLi 메타문자: 꺾쇠, 따옴표, 백틱, 역슬래시
const DANGEROUS = /[<>"'`\\]/;
const DANGEROUS_G = /[<>"'`\\]/g;

// 위험 문자 포함 여부 (에러 표시 판정용)
export function hasForbiddenChars(value) {
	if (typeof value !== 'string') return false;
	return DANGEROUS.test(value);
}

// 사용자에게 보여줄 에러 메시지
export const FORBIDDEN_CHARS_MSG = '사용할 수 없는 문자(< > " \' ` \\)가 포함되어 있습니다.';

// 검색어·메시지·일반 텍스트용 최종 방어(제출 직전)
export function sanitizeText(value) {
	if (typeof value !== 'string') return value;
	return value.replace(DANGEROUS_G, '');
}

// 아이디용: 위험 문자 + 공백 제거
export function sanitizeId(value) {
	if (typeof value !== 'string') return value;
	return value.replace(DANGEROUS_G, '').replace(/\s/g, '');
}
